'use client'

import { useEffect } from 'react'
import { useTranslations } from 'next-intl'
import { Button } from '@/components/ui/button'
import { reportClientError } from '@/lib/report-client-error'

interface ErrorPageProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  const t = useTranslations('errors')

  useEffect(() => {
    console.error(error)
    reportClientError('render', error)
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center space-y-4 max-w-md">
        <p className="text-6xl font-bold text-muted-foreground">500</p>
        <h1 className="text-2xl font-semibold text-foreground">{t('somethingWentWrong')}</h1>
        <p className="text-muted-foreground">{t('tryAgainOrContact')}</p>
        <Button onClick={reset}>{t('tryAgain')}</Button>
      </div>
    </div>
  )
}
